module.exports = __webpack_public_path__ + "images/iType-b77529.png";